<template>
  <div class="typesearch-wrapper" :class="($store.state.rent.query && temp) ? 'input--has--value' : ''">
  <!--
      <Autocomplete
        :search="searchResults"
        :placeholder=$store.getters.language.enter_space_name
        :aria-label=$store.getters.language.enter_space_name
      >
  -->
    <Autocomplete
      :search="searchResults"
      placeholder=""
      aria-label=""
      :debounce-time="800"
      :get-result-value="getResultValue"
      :default-value="getDefaultValue()"
      @submit="handleSubmit"
      @keyup="handleUpdate"
      ref="typeahead"
    >
      <template #result="{ result, props }">
        <li v-bind="props" class="autocomplete-result-item">

        <template>
          <a @click.prevent="commitValue(result.lat, 'lat'), commitValue(result.lng, 'lng'), commitValue(result.title, 'query')">
            <div class="autocomplete-result-icon">
              <span v-if="result.result_type == 'pin'" class="icon-pin"></span>
              <span v-if="result.result_type == 'listing_group'" class="icon-market" style="color: #64DCBE"></span>
            </div>
            <div class="autocomplete-result-title">
              {{ result.title }}
            </div>
          </a>
        </template>
        </li>
      </template>
    </Autocomplete>
    <span class="input--arrow">
      <svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.191434 9.84396C-0.0475602 9.62106 -0.0651732 9.24159 0.152094 8.99639L3.69331 5L0.152095 1.00361C-0.0651731 0.758412 -0.0475601 0.378944 0.191434 0.15604C0.430429 -0.0668642 0.800303 -0.0487938 1.01757 0.196401L4.79721 4.46186C5.0676 4.767 5.0676 5.233 4.79721 5.53814L1.01757 9.8036C0.800303 10.0488 0.430429 10.0669 0.191434 9.84396Z" fill="#7A7A7A"/>
      </svg>
    </span>
  </div>
</template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue'
import axios from 'axios'

export default {
  name: 'TypeSearch',
  data: () => ({
    inputValue: null,
    query: {
      q: null
    },
    temp: null,
    results: []
  }),
  props: [],
  components: {
    Autocomplete
  },
  watch: {
  },
  computed: {
  },
  mounted () {

    // Method to fire map center update from TypeSearch component
    this.$root.$on('resetTypeSearch', () => {
        // your code goes here
        this.resetTypeSearch()
    })

  },
  created () {
  },
  methods: {
    resetTypeSearch () {
      this.query.q = null
      this.temp = null
      this.$refs.typeahead.value = null
    },
    commitValue (value, field) {
      this.$store.commit(field, value)
      this.$root.$emit('updateMapCenter')
      // this.$root.$emit('updateMapZoom')
    },
    searchResults (query) {
      if (query.length < 1) {
        return [];
      } 
      var token = document.head.querySelector("[name=csrf-token]").content;
      const res = axios.get('/rent/search_string_return.json?search_keyword=' + query + '&keyword=' + query,
                  { headers: {
                    'Content-type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-Token': token
                  }
                  }).then(res => {
                    return res.data;
                  }).catch(err => {
                    console.log("Error: "+ err)
                  })
      return res;
    },
    getResultValue(result) {
      return result.title
    },
    setDefaultZoom(result) {
      return this.$store.state.rent.query
    },
    getDefaultValue(result) {
      return this.$store.state.rent.query
    },
    handleUpdate(result) {
      this.temp  = result.target.value
    },
    handleSubmit(result) {
      console.log(result)
      this.commitValue(result.lat, 'lat')
      this.commitValue(result.lng, 'lng')
      this.commitValue(result.title, 'query')
      this.commitValue(result.location_type, 'location_type')
      this.setZoomLevel(result.location_type)
    },
    setZoomLevel(type) {
      if (type === 'locality') {
        this.$root.$emit('updateMapZoom', 10)
      } else {
        this.$root.$emit('updateMapZoom', 16)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../scss/global/includes";

.icon-market .highlight{
  color: $primary;
}

.typesearch-wrapper {
  z-index: 1003;
  position: relative;
  padding: 0px;
  margin-bottom: 8px;
  &.input--has--value {
    .input--arrow svg path  {
      fill: $primary-grey;
    }
    ::v-deep .autocomplete input {
      color: $primary-grey;
      border: 1px solid $primary-grey;
      background: $blue-15-opacity;
    }
  }

}

.typesearch-wrapper ::v-deep .autocomplete {
  position: relative;
  width: 100%;

  input {
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
    outline: none;
    font-size: 14px;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid $divider-dark;
    color: $primary-grey;
    border-radius: 4px;
    margin-bottom: 0px;
    padding: 16px 10px;
    display: block;
    width: 100%;
    outline: none;
    background: #FFFFFF;

    @include placeholder {
      color: $primary-grey;
    }
  }

  &.input--has--value {
    .input--arrow svg path  {
      fill: $primary;
    }
    input {
      color: $primary;
      border: 1px solid $primary;
    }
  }

  .autocomplete-result-list {
    background: #FFFFFF;
    list-style: none;
    width: 100%;
    box-sizing: border-box;
    float: left;
    margin: 0;
    padding: 0;
    max-height: 320px;
    overflow-x: hidden;
    overflow-y: scroll;
    border: 0px solid $mid-light;
    border-top: 0;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0,  0.2%);
  }
  .autocomplete-result-icon {
    height: 100%;
    width: 100%;
    padding: 5px;
    position: relative;
    img {
      height: 100%;
      width: 100%;
      object-position: cover;
    }
    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 15px;
      color: $mid-light;
    }
  }
  .autocomplete-result-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    display: block;
    max-width: 100%;
    overflow: hidden;
    padding: 14px 0;
  }
  .autocomplete-result-item  {
    border-bottom: 1px solid $mid-light;
    overflow: hidden;
    &:last-child {
      border: 0;
    }
  }

  .autocomplete-result[aria-selected=true] {
      background-color: rgba(0,0,0,.06);
  }

  .autocomplete-result-item a {
    display: grid;
    grid-gap: 0px;
    align-items: center;
    transition: all 0.3s ease-in-out;
    grid-template-columns: 30px auto;
    font-size: 12px;
    cursor: pointer;
    color: $primary-grey;
  }
}

.typesearch-wrapper .input--arrow {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translate(0px, -50%);
}
</style>
